/**
 *@author xujinjiang
 *@date 2022/3/2 14:45
 */
import { UrlConfig } from '@/config/UrlConfig';
export class HomeUrlConfig {
  public static getUserInfo = `${UrlConfig.websiteBaseurl}/thirdparty/developer`;

  public static getUserLoginLog = `${UrlConfig.websiteBaseurl}/thirdparty/developer/log`;

  public static logout = `${UrlConfig.websiteBaseurl}/thirdparty/logout`;
}
